import { gql } from '@apollo/client';

export const ACCEPT_REFERRAL_CODE = gql`
  mutation AcceptReferralCode($input: AcceptReferralCodeInput!) {
  acceptReferralCode(input: $input)
}
`;